import { DeleteIcon, EditIcon } from "../../images/icons/website-icons";
import { formattedLongDate2 } from "../common-data/Converts";

export const notificationColumn = (handleEdit, handleDelete, filters) => {
  return [
    {
      dataField: "gym_id",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.gym_id || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "image",
      text: "Image",
      formatter: (cell, row) => {
        return (
          <>
            {row?.image ? (
              <img
                src={row?.image || ""}
                alt={row?.name || "NA"}
                className="image"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
            ) : (
              "NA"
            )}
          </>
        );
      },
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.type || "NA"}</span>;
      },
    },
    {
      dataField: "account_type",
      text: "Account Type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.account_type || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "title",
      text: "Title",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.title || "NA"}</span>
        );
      },
    },
    {
      dataField: "message",
      text: "message",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100"
            style={{
              fontSize: "14px",
            }}
          >
            {row?.message || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.status || "NA"}</span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {formattedLongDate2(row?.date_added) || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Trigger Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date ? row.date : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <div className="actionButtonContainer">
            {filters?.notification_status === "pending" && (
              <button
                className="actionBtn icon edit"
                onClick={() => handleEdit(row)}
              >
                <EditIcon />
              </button>
            )}
            <button
              className="actionBtn icon edit"
              onClick={() => handleDelete(row?.uid)}
            >
              <DeleteIcon />
            </button>
          </div>
        );
      },
    },
  ];
};
